'use strict';/* global define */define('modules/quick-feedback/components/quick-feedback-task/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
controller.$inject = ["Dispatcher", "TROPHY_SCALE", "EVENTS"];
function controller(Dispatcher,TROPHY_SCALE,EVENTS){// jshint validthis:true
var ctrl=this;ctrl.trophyScale=TROPHY_SCALE;ctrl.closeTasks=function(){Dispatcher.dispatch(EVENTS.CLOSE_TASKS);};}module.exports=controller;});
